// extracted by mini-css-extract-plugin
export default {"Card":"MakeOrderPage_Card__a7WIt"};